//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Vue from "vue";
import {UserMixin, AppMixin} from "~/node_modules/sitis-nuxt/lib/mixins";
import {required, minLength, between, email} from "vuelidate/lib/validators";
import CallBackModal from "~/components/modals/CallBackModal.vue";
import {comagicAddOfflineRequest} from "~/helpers/comagic";

export default Vue.extend({
  data() {
    return {
      isModalOpen: false,
      appointmentForm: {
        phone: "",
        name: "",
        childAge: "",
        message: {
          date: "",
          time: "",
        },
        email: "",
        mailingAgreement: false
      },
      swiperOptionsDate: {
        spaceBetween: 8,
        slidesPerView: 4,
        loop: false,
        navigation: {
          nextEl: ".swiper-button-next--date",
          prevEl: ".swiper-button-prev--date",
        },
      },
      swiperOptionsTime: {
        spaceBetween: 10,
        slidesPerView: 5,
        loop: false,
        navigation: {
          prevEl: ".swiper-button-prev--time",
          nextEl: ".swiper-button-next--time",
        },
      },
      activeTab: 1,
      activeHours: [],
      isShowCalendar: false,
      isShowHours: false,
      dates: [],
      time: [],

      appointmentData: "",
      phoneNumber: "",

      isPrivacyPolicy: false,
      isConsentProcessing: false,
      isAgreeReceiveInformation: true,

      isFocusedInput: {
        phone: false,
      }
    };
  },
  mixins: [UserMixin, AppMixin],
  validations: function () {
    let appointmentForm = {
      email: {required, email},
      name: {required, minLength: minLength(2)},
      phone: {required, minLength: minLength(15)}
    };

    // Если выбран ребенок, то
    // добавляеям обязательное поле возраст ребенка
    if (this.activeTab === 2) {
      appointmentForm['childAge'] = {
        required,
        between: between(0, 18)
      };
    }

    return {
      appointmentForm
    }
  },
  components: {
    CallBackModal,
  },
  computed: {
    setTime() {
      const startTime = 9;
      const timeRange = [];
      for (let key = 0; key <= 10; key++) {
        timeRange.push({
          from: `${key + startTime}:00`,
          to: `${key + startTime}:30`,
          value: `${key + startTime}:00-${key + startTime}:30`,
        });
        timeRange.push({
          from: `${key + startTime}:30`,
          to: `${key + startTime + 1}:00`,
          value: `${key + startTime}:30-${key + startTime + 1}:00`,
        });
      }
      return timeRange;
    },
    isShowQrCodeMessage: function () {
      return Boolean((this.vars['Уведомление о QR-коде ВКЛ'] || '').toLowerCase() === 'да')
    },

    errorEmail: function () {
      const isDirty = Boolean(this.$v.appointmentForm?.email?.$dirty);
      if (!isDirty) {
        return ''
      }

      if (!this.$v.appointmentForm.email.required) {
        return "Обязательно к заполнению"
      }
      if (!this.$v.appointmentForm.email.email) {
        return "Неверный формат"
      }

      return ''
    },
    isEmailRequired: function () {
      return true
    }
  },
  created() {
    this.setDates();
  },
  mounted() {
    if (!!this.user) {
      this.appointmentForm.name = this.user?.name || "";

      let phone = ('' + this.user?.phone).replace(/\D/g, '').substr(1);
      let phoneMatch = phone.match(/^(\d{3})(\d{2})(\d{2})(\d{3})$/);
      this.appointmentForm.phone = Boolean(this.user?.phone) ? `(${phoneMatch[1]}) ${phoneMatch[2]}-${phoneMatch[3]}-${phoneMatch[4]}` : "";
    }
  },
  methods: {
    setDates() {
      const dates = [];
      for (let index = 0; index <= 30; index++) {
        dates.push({
          date: this.$moment().add(index, "d").format("DD MMMM"),
          day: this.$moment().add(index, "d").format("dd"),
        });
      }
      this.dates = dates;
    },
    openModal() {
      this.isModalOpen = true;
      this.$nextTick(() => {
        this.$modal.show("callback-modal");
      });
    },
    async onSubmitForm() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return null;
      } else {
        const messages = [];

        if (this.activeTab === 2) {
          messages.push(`Комментарий: Прием ребенка. Возраст ребенка: ${this.appointmentForm?.childAge || 'неопределен'}`);
        }
        const form = {
          type: "Быстрая запись на прием",
          name: this.appointmentForm.name,
          phone: this.appointmentForm.phone,
          message: messages.join("<br>"),
          email: this.appointmentForm.email,
          additional_data: {
            is_marketing: this.appointmentForm.mailingAgreement
          }
        };
        try {
          const res = await this.$api.agent.transport.post("form/send", form);
          if (res) {
            await comagicAddOfflineRequest({
              name: form.name,
              email: form.email,
              phone: form.phone,
              message: form.message,
            })

            this.$router.push("/zapis/success");

            this.$ga.event({
              eventCategory: 'event',
              eventAction: 'record',
              eventLabel: 'NA Записаться на прием'
            });
            if ((window?.Comagic) && Comagic.trackEvent) {
              Comagic.trackEvent("Услуги", "Запись");
            }
            this.$vkGoalWr("QuickRecord", {}, process.env.vkPixelCode);

            const reachGoal = Boolean(this.isEmailRequired) ? 'zapisbystrayaemail' : 'zapisbystraya';
            if (this.$yandexMetrika.reachGoal) {
              this.$yandexMetrika.reachGoal(reachGoal);
            }
          }
        } catch (error) {
          console.log(error.response, "err");
        }
      }
    },
    focusPhone: function () {
      this.isFocusedInput.phone = true;
    },
    blurPhone: function () {
      this.isFocusedInput.phone = false;
    }
  },
});
